import { faBell, faEnvelope, faLocationDot, faPhone } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import fbLogo from '../Images/socialLogo/facebook.png';
import insLogo from '../Images/socialLogo/instagram.png';
import githubLogo from '../Images/socialLogo/github.png';
import linkedinLogo from '../Images/socialLogo/linkedin.png';
import { Link } from 'react-router-dom';


const Footer = () => {

    const handleNewLetterEmail = e => {
        e.preventDefault();
        e.target.reset();
    }

    return (
        <div className='footer-section  text-gray-400 bg-gray-900 mt-20 py-12' id='footer'>
            <div className='md:px-20 px-10'>
                <div className='grid gap-10 lg:grid-cols-4 md:grid-cols-2 grid-cols-1 footer_content'>
                    <div className=' md:w-full w-11/12'
                        data-aos="fade-down"
                        data-aos-easing="linear"
                        data-aos-duration="500"
                    >
                        <Link to='/'><h2 className='logo_title text-2xl font-bold ml-2 md:ml-0 text-white'>Shakil<span className='text-green-500 '>Ahmed</span></h2></Link>
                        <p className='text-md text-gray-400 mb-2'> I'm Md. Shakil Ahmed Junior Web Developer and Web Designer with one year experience. </p>
                        <p> <FontAwesomeIcon icon={faLocationDot}></FontAwesomeIcon> <span className='text-sm'>Kapasia, Gazipur, Dhaka</span></p>
                        <p> <FontAwesomeIcon icon={faEnvelope}></FontAwesomeIcon> <span className='text-sm'>ahmedshakil0512@gmail.com </span></p>
                        <p> <FontAwesomeIcon icon={faPhone}></FontAwesomeIcon>  <span className='text-sm'>+8801729107200 </span></p>
                    </div>
                    <div className='md:w-full w-11/12'
                        data-aos="fade-down"
                        data-aos-easing="linear"
                        data-aos-duration="1000"
                    >
                        <h2 className='text-2xl font-bold text-white  mb-2'>Quick Links</h2>
                        <a target="_blank" rel="noreferrer" className='mr-1 text-md ' href='/home#banner'>BANNER</a> <br /> 
                        <a target="_blank" rel="noreferrer" className='mr-1 text-md ' href='/home#about'> ABOUT ME </a> <br /> 
                        <a target="_blank" rel="noreferrer" className='mr-1 text-md ' href='/home#services'>SERVICES</a> <br /> 
                        <a target="_blank" rel="noreferrer" className='mr-1 text-md ' href='/home#products'>PROJECTS</a> <br /> 
                        <a target="_blank" rel="noreferrer" className='mr-1 text-md ' href='/home#contact'>CONTACT ME</a> 
                    </div>
                    <div className='md:w-full w-11/12'
                        data-aos="fade-down"
                        data-aos-easing="linear"
                        data-aos-duration="1500"
                    >
                        <h2 className='text-2xl font-bold text-white mb-2'> Follow Me </h2>
                        <div className='social_mediaIcon flex mt-3 mb-2'>
                            <a href="https://www.facebook.com/codermdshakil/" target="_blank"  > <img src={fbLogo} className="mr-2" alt="fb_logo" /></a>

                            <a href="https://www.linkedin.com/in/codermdshakil/" target="_blank"  > <img src={linkedinLogo} className="mr-2" alt="in_logo" /> </a>

                            <a href="https://github.com/codermdshakil/" target="_blank"  > <img src={githubLogo} className="mr-2" alt="Github_Logo" /></a>

                            <a href="https://instagram.com/codermdshakil" target="_blank"  >    <img src={insLogo} alt="instagram_logo" /> </a>

                        </div>
                    </div>
                    <div className='md:w-full w-11/12'
                        data-aos="fade-down"
                        data-aos-easing="linear"
                        data-aos-duration="2000"
                    >
                        <h2 className='text-2xl font-bold text-white mb-2'>NewsLetter</h2>
                        <form onSubmit={handleNewLetterEmail}>
                            <input type="text" placeholder='Email' name='email' className='w-full py-2 px-3 rounded-lg' required />
                            <button className='btn btn-md bg-red-600 text-white  subscribe w-full mt-4 text-center mx-auto ring-2 ring-white'>Subscribe Now <FontAwesomeIcon className='ml-2' icon={faBell} /></button>
                        </form>
                    </div>
                </div>
                <div>
                    <p className='text-center pt-6'> &copy; Copyright <span className='text-primary'> <a target="_blank" href="https://www.linkedin.com/in/codermdshakil/" >Md. Shakil Ahmed </a></span> Allrights Reserved | <span className='text-secondary'> <a href="http://web.programming-hero.com/" target="_blank" rel="noopener noreferrer"> Programming-hero </a></span> Learner -2022 </p>
                </div>
            </div>
        </div>
    );
};

export default Footer;